import ImageWithBasePath from "@/components/image-with-base-path"
import { all_routes } from "@/routes/all_routes"
import { Link } from "react-router"


const TeamSectionTwo = () => {
  return (
   <>
  {/* Team Section */}
  <section className="team-section-fourteen section">
    <div className="container">
      <div
        className="section-header section-header-fourteen title-white section-btn wow fadeInUp"
        data-wow-duration="1s"
      >
        <div>
          <h2 className="section-title">
            <span className="section-line">Professionals</span> Making{" "}
            <span className="subtitle">Your Skin Beauty</span>
          </h2>
        </div>
        <Link to={all_routes.mapGrid} className="btn btn-secondary theme-14-btn">
          <i className="isax isax-bubble5 me-2" />
          View All Members
        </Link>
      </div>
      <div className="row g-4">
        {/* Doctor Item */}
        <div
          className="col-xl-3 col-md-6 d-flex wow fadeInUp"
          data-wow-delay="0.2s"
          data-wow-duration="1s"
        >
          <div className="team-item-fourteen flex-fill">
            <div className="team-img">
              <Link to={all_routes.doctorProfile1}>
                <ImageWithBasePath
                  src="assets/img/team/team-skin-1.png"
                  alt="Diana Williams"
                />
              </Link>
              <div className="hover-icons">
                <button type="button" className="add-icon">
                  <i className="isax isax-add" />
                </button>
                <div className="social-icons">
                  <Link to="#" aria-label="facebook">
                    <i className="fab fa-facebook-f" />
                  </Link>
                  <Link to="#" aria-label="twitter">
                    <i className="fab fa-twitter" />
                  </Link>
                  <Link to="#" aria-label="instagram">
                    <i className="fab fa-instagram" />
                  </Link>
                  <Link to="#" aria-label="linkedin">
                    <i className="fab fa-linkedin-in" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="team-content">
              <h3 className="custom-title">
                <Link to={all_routes.doctorProfile1}>Diana Williams</Link>
              </h3>
              <p>Medical Facial Specialists</p>
            </div>
          </div>
        </div>
        {/* Doctor Item End */}
        {/* Doctor Item */}
        <div
          className="col-xl-3 col-md-6 d-flex wow fadeInUp"
          data-wow-delay="0.2s"
          data-wow-duration="1s"
        >
          <div className="team-item-fourteen flex-fill">
            <div className="team-img">
              <Link to={all_routes.doctorProfile1}>
                <ImageWithBasePath
                  src="assets/img/team/team-skin-2.png"
                  alt="George Pearson"
                />
              </Link>
              <div className="hover-icons">
                <button type="button" className="add-icon">
                  <i className="isax isax-add" />
                </button>
                <div className="social-icons">
                  <Link to="#" aria-label="facebook">
                    <i className="fab fa-facebook-f" />
                  </Link>
                  <Link to="#" aria-label="twitter">
                    <i className="fab fa-twitter" />
                  </Link>
                  <Link to="#" aria-label="instagram">
                    <i className="fab fa-instagram" />
                  </Link>
                  <Link to="#" aria-label="linkedin">
                    <i className="fab fa-linkedin-in" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="team-content">
              <h3 className="custom-title">
                <Link to={all_routes.doctorProfile1}>George Pearson</Link>
              </h3>
              <p>Skin Allergy Expert</p>
            </div>
          </div>
        </div>
        {/* Doctor Item End */}
        {/* Doctor Item */}
        <div
          className="col-xl-3 col-md-6 d-flex wow fadeInUp"
          data-wow-delay="0.2s"
          data-wow-duration="1s"
        >
          <div className="team-item-fourteen flex-fill">
            <div className="team-img">
              <Link to={all_routes.doctorProfile1}>
                <ImageWithBasePath
                  src="assets/img/team/team-skin-3.png"
                  alt="Jannie Morales"
                />
              </Link>
              <div className="hover-icons">
                <button type="button" className="add-icon">
                  <i className="isax isax-add" />
                </button>
                <div className="social-icons">
                  <Link to="#" aria-label="facebook">
                    <i className="fab fa-facebook-f" />
                  </Link>
                  <Link to="#" aria-label="twitter">
                    <i className="fab fa-twitter" />
                  </Link>
                  <Link to="#" aria-label="instagram">
                    <i className="fab fa-instagram" />
                  </Link>
                  <Link to="#" aria-label="linkedin">
                    <i className="fab fa-linkedin-in" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="team-content">
              <h3 className="custom-title">
                <Link to={all_routes.doctorProfile1}>Jannie Morales</Link>
              </h3>
              <p>Chemical Peel Specialists</p>
            </div>
          </div>
        </div>
        {/* Doctor Item End */}
        {/* Doctor Item */}
        <div
          className="col-xl-3 col-md-6 d-flex wow fadeInUp"
          data-wow-delay="0.2s"
          data-wow-duration="1s"
        >
          <div className="team-item-fourteen flex-fill">
            <div className="team-img">
              <Link to={all_routes.doctorProfile1}>
                <ImageWithBasePath src="assets/img/team/team-skin-4.png" alt="Mark Bowman" />
              </Link>
              <div className="hover-icons">
                <button type="button" className="add-icon">
                  <i className="isax isax-add" />
                </button>
                <div className="social-icons">
                  <Link to="#" aria-label="facebook">
                    <i className="fab fa-facebook-f" />
                  </Link>
                  <Link to="#" aria-label="twitter">
                    <i className="fab fa-twitter" />
                  </Link>
                  <Link to="#" aria-label="instagram">
                    <i className="fab fa-instagram" />
                  </Link>
                  <Link to="#" aria-label="linkedin">
                    <i className="fab fa-linkedin-in" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="team-content">
              <h3 className="custom-title">
                <Link to={all_routes.doctorProfile1}>Mark Bowman</Link>
              </h3>
              <p>Acne Treatment Specialists</p>
            </div>
          </div>
        </div>
        {/* Doctor Item End */}
      </div>
    </div>
    <ImageWithBasePath
      src="assets/img/bg/team-bg-02.png"
      alt="bg"
      className="img-fluid team-bg-01"
    />
  </section>
  {/* Team Section End */}
</>

  )
}

export default TeamSectionTwo